import { Box, Button, Stack, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import ContinueAndPreviewContainer from 'components/v2/container/ContinueAndPreviewContainer';
import { useLocalization } from 'localization';
import { ArrowRightIcon } from 'components/v2/icons/ArrowRightIcon';
import { SliderField } from 'components/v2/slider/SliderField';
import GoogleMapViewer from 'components/v2/maps/GoogleMapViewer';
import { createAdsCampaignOrderStore } from 'stores/createAdsCampaignOrderStore';
import AdsPreview from 'components/v2/shared/AdsPreview';

const CreateAdsCampaignOrderStep4 = () => {
  const { t } = useLocalization();
  const { goToStep } = createAdsCampaignOrderStore();
  const { control, watch } = useFormContext();

  const handleContinue = () => {
    goToStep(5);
  };

  return (
    <Stack direction="row" justifyContent="space-between" sx={{ height: '100%' }}>
      <Stack sx={{ width: '100%', padding: '1rem 1rem 1rem 0', overflowY: 'auto' }} mb={{ xs: 10, md: 0 }} gap={2}>
        <Stack gap={1.5}>
          <Typography variant="h3">{t('orders.pages.new.ads.targetYourCampaign')}</Typography>
          <Typography variant="body1">
            Choose the right audience for your real estate ads. Define your target buyers or renters by location,
            demographics, and interests to make sure your campaign reaches the people most likely to engage with your
            properties.
          </Typography>
        </Stack>
        <SliderField defaultValue={20} name="radius" control={control} label={t('Radius: 20km')} required />

        <Box sx={{ width: '100%', height: '100%' }}>
          <GoogleMapViewer lng={watch('longitude')} lat={watch('latitude')} zoom={15} />
        </Box>
      </Stack>

      <ContinueAndPreviewContainer
        continueElement={
          <Stack gap={2}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ display: { xs: 'none', sm: 'flex' } }}
            >
              <Typography variant="h4">{t('common.terms.totalPrice')}</Typography>
            </Stack>
            <Button
              size="large"
              // loading={isLoading || orderLoading}
              onClick={handleContinue}
              variant="contained"
              fullWidth
              endIcon={<ArrowRightIcon />}
              sx={{ minWidth: 'fit-content' }}
              // disabled={isOrderEmpty || isProductError}
            >
              {t('common.terms.continue')}
            </Button>
          </Stack>
        }
        previewElement={
          <AdsPreview
            loading={false}
            src={
              'https://imageresizing.esoft.com/?width=1200&height=1200&format=webp&quality=75&fit=contain&image=https://cdn-m2.esoftsystems.com/10100603/DREJEB%C3%86NKEN+22%2C+5260+ODENSE+S/10225159504/827095412/ORIGINAL/DJI-20250703100412-0037-D.jpg'
            }
          />
        }
      />
    </Stack>
  );
};

export default CreateAdsCampaignOrderStep4;
